const zhCN = {
  tabGlassesSettings: '智能眼镜参数设置',
  glassesSettingsTitle: '智能眼镜参数设置',

  registerQRCode: '注册二维码',
  QRCodeUseDesc: '请使用智能眼镜扫描二维码，然后进行参数设置！',
  QRCodeExpiryTimeDesc: '注册二维码有效期至',

  dataSyncTitle: '数据同步',
  dataSyncBtn: '点击按钮，进行数据全量同步',

  notifySuccess: '成功',
  syncDataSuccess: '数据已同步到智能眼镜后台！',

  notifyError: '失败',
  getQRCodeError: '获取注册二维码失败！',
  syncDataError: '同步数据失败！',

  QRCodeLoading: '加载二维码...',
  syncDataWaiting: '同步中，请耐心等候...',
  syncDataDesc: '数据同步会花费较长时间，同步时勿有其他操作，请耐心等候！'
}

const enUS = {
  tabGlassesSettings: 'Smart Glasses Settings',
  glassesSettingsTitle: 'Smart Glasses Settings',

  registerQRCode: 'QR code of Register',
  QRCodeUseDesc: 'Please use smart glasses to scan the QR code and then set the parameters!',
  QRCodeExpiryTimeDesc: 'QR code of register is valid until',

  dataSyncTitle: 'Data Sync',
  dataSyncBtn: 'Click me to perform full data synchronization',

  notifySuccess: 'Success',
  syncDataSuccess: 'Data has been synchronized to the smart glasses backstage supporter!',

  notifyError: 'Error',
  getQRCodeError: 'Failed to get registration QR code!',
  syncDataError: 'Failed to synchronize data!',

  QRCodeLoading: 'Loading QR code...',
  syncDataWaiting: 'Synchronizing, please wait patiently...',
  syncDataDesc: 'Data synchronization will take a long time, don\'t perform other operations during that time. Please wait patiently.'
}

export default { zhCN, enUS }